import {
  getLeoUuid,
  LeoUUID,
  getObject,
  LeoRPCRequest,
  LeoRPCResponse,
  LeoRPCError,
  LeoRPCResult,
  LeoRPC
} from "@surya-digital/leo-ts-types";
import { EmailCycleDetails, EmailCycleDetailsDTO } from "./emailCycleDetails";
/* eslint-disable import/export */
export abstract class GetEmailCycleDetailsRPC implements
  LeoRPC<GetEmailCycleDetailsRPC.Request, GetEmailCycleDetailsRPC.Response, GetEmailCycleDetailsRPC.Errors.Errors>
{
  abstract execute(
    request: GetEmailCycleDetailsRPC.Request
  ): Promise<LeoRPCResult<GetEmailCycleDetailsRPC.Response, GetEmailCycleDetailsRPC.Errors.Errors>>;
}

export namespace GetEmailCycleDetailsRPC {

  export class InvalidRequestError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidRequestError";
    }
  }

  export interface RequestDTO {
    scheduleId: string;
  }
  
  export class Request implements LeoRPCRequest {
    readonly isGetEmailCycleDetailsRPCRequest: boolean = true;
  
    readonly scheduleId: LeoUUID;
  
  
    constructor(
    scheduleId: LeoUUID
    ) {
      this.scheduleId = scheduleId;
    }
  
    static fromDTO(dto: RequestDTO): Request {
      const scheduleId = getLeoUuid(dto, "scheduleId", InvalidRequestScheduleIdError);
      return new Request(
        scheduleId
      );
    }
  
    toDTO(): RequestDTO {
      const dto: RequestDTO = {
          scheduleId: this.scheduleId.toDTO()
      };
      return dto;
    }
    }
  
  Request.prototype.toString = function toString(): string {
    return `GetEmailCycleDetailsRPC(scheduleId='${this.scheduleId}')`;
  };
  

  export class InvalidResponseError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidResponseError";
    }
  }

  export interface ResponseDTO {
    emailCycleDetails: EmailCycleDetailsDTO;
  }
  
  export class Response implements LeoRPCResponse {
    readonly isGetEmailCycleDetailsResponse: boolean = true;
  
    readonly emailCycleDetails: EmailCycleDetails;
  
  
    constructor(
    emailCycleDetails: EmailCycleDetails
    ) {
      this.emailCycleDetails = emailCycleDetails;
    }
  
    static fromDTO(dto: ResponseDTO): Response {
      const emailCycleDetails = EmailCycleDetails.fromDTO(getObject(dto, "emailCycleDetails", InvalidResponseEmailCycleDetailsError));
      return new Response(
        emailCycleDetails
      );
    }
  
    toDTO(): ResponseDTO {
      const dto: ResponseDTO = {
          emailCycleDetails: this.emailCycleDetails.toDTO()
      };
      return dto;
    }
    }
  
  Response.prototype.toString = function toString(): string {
    return `GetEmailCycleDetails(emailCycleDetails='${this.emailCycleDetails}')`;
  };
  

  export enum RPCError {
    InvalidScheduleId = "INVALID_SCHEDULE_ID"
  }

  export namespace Errors {
    
    export interface InvalidScheduleIdDTO {
      code: string;
    }
    
    export class InvalidScheduleId extends LeoRPCError<RPCError> {
      readonly isInvalidScheduleId: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.InvalidScheduleId;
        super(code);
      }
    
    
      toDTO(): InvalidScheduleIdDTO {
        const dto: InvalidScheduleIdDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    InvalidScheduleId.prototype.toString = function toString(): string {
      return `GetEmailCycleDetailsRPC.INVALID_SCHEDULE_ID()`;
    };
    

    export type Errors = InvalidScheduleId;
    export type ErrorsDTO = InvalidScheduleIdDTO;

    export const fromDTO = (dto: ErrorsDTO): Errors => {
      switch (dto.code) {
        case RPCError.InvalidScheduleId:
          return new InvalidScheduleId();
        default:
          throw new InvalidResponseError(`Unexpected error code: ${dto.code}`);
      }
    };
  }
}

export class InvalidRequestScheduleIdError extends GetEmailCycleDetailsRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestScheduleIdError";
  }
}

export class InvalidResponseEmailCycleDetailsError extends GetEmailCycleDetailsRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseEmailCycleDetailsError";
  }
}

export class InvalidResponseInvalidScheduleIdError extends GetEmailCycleDetailsRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseInvalidScheduleIdError";
  }
}

